const mono = "font-paw-mono";

/**
 * The `session('status')` / error banner from layouts/auth.blade.php, shown
 * above the form column on the auth screens.
 */
export function AuthNotice({
  tone = "ok",
  children,
}: {
  tone?: "ok" | "error" | "warn";
  children: React.ReactNode;
}) {
  if (tone === "error") {
    return (
      <div
        role="alert"
        className={`mb-6 border border-(--paw-danger) bg-(--paw-danger-wash) px-4 py-3 ${mono} text-[12px] text-(--paw-paper)`}
      >
        {children}
      </div>
    );
  }
  if (tone === "warn") {
    return (
      <div
        role="alert"
        className={`mb-6 flex items-start gap-2 border border-amber-400 bg-amber-400/10 px-4 py-3 ${mono} text-[12px] text-(--paw-paper)`}
      >
        <i className="fa-solid fa-triangle-exclamation mt-0.5 text-amber-400" aria-hidden="true" />
        <span>{children}</span>
      </div>
    );
  }
  return (
    <div
      className={`mb-6 flex items-center gap-2 border border-(--paw-line-strong) bg-(--paw-panel) px-4 py-3 ${mono} text-[12px] text-(--paw-paper)`}
    >
      <i className="fa-solid fa-check text-(--paw-signal)" aria-hidden="true" />
      {children}
    </div>
  );
}
